import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { catalogBibShape } from '@bibliocommons/bc-prop-types';
import DeleteUgcForm from 'app/components/bibs/shared/ugc/DeleteUgcForm';
import ModalContainer from 'app/components/shared/Modal/ModalContainer';

export default function DeleteVideoModal({
  videoId,
  catalogBib,
  videosActions,
  handleSuccess,
  modalActions,
  videosTransactions
}) {
  const modalKey = `delete-video-${videoId}`;

  function handleClose() {
    modalActions.closeModal(modalKey);
  }

  return (
    <ModalContainer className="cp-delete-video-modal" modalKey={modalKey} handleClose={handleClose} size="small">
      <DeleteUgcForm
        ugcType="video"
        id={videoId}
        catalogBib={catalogBib}
        removeUgcAction={videosActions.removeVideo}
        transactions={videosTransactions}
        handleClose={handleClose}
        handleSuccess={handleSuccess}
      />
    </ModalContainer>
  );
}

DeleteVideoModal.propTypes = {
  videoId: PropTypes.number.isRequired,
  catalogBib: catalogBibShape.isRequired,
  handleSuccess: PropTypes.func,
  videosActions: PropTypes.objectOf(PropTypes.func).isRequired,
  videosTransactions: ImmutablePropTypes.map.isRequired,
  modalActions: PropTypes.objectOf(PropTypes.func).isRequired
};
